import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { Nhfpipe } from '../pages/home/nhfpipe';
//import { NewdrugPage } from '../pages/newdrug/newdrug';
//import { LoginPage } from '../pages/login/login';
import { FirebaseProvider } from '../providers/firebase/firebase';
import { HttpModule } from '@angular/http';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireModule } from 'angularfire2';
import * as firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyCXqS38yE4j_-Llyj6JDkh9hMy-1yEn0sc",
    authDomain: "rxauth.firebaseapp.com",
    databaseURL: "https://rxauth.firebaseio.com",
    projectId: "rxauth",
    storageBucket: "rxauth.appspot.com",
    messagingSenderId: "309148012980"
  };

firebase.initializeApp(firebaseConfig);

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    Nhfpipe,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    AngularFireDatabaseModule,
    AngularFireModule.initializeApp(firebaseConfig),
    IonicModule.forRoot(MyApp, {}, 
{
  links: [
    { loadChildren: '../pages/drug/drug.module#DrugPageModule', name: 'DrugPage', segment: 'drug', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/login/login.module#LoginPageModule', name: 'LoginPage', segment: 'login', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/newdrug/newdrug.module#NewdrugPageModule', name: 'NewdrugPage', segment: 'newdrug', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/nhf/nhfdrug.module#NhfDrugModule', name: 'NhfDrug', segment: 'nhfdrug', priority: 'low', defaultHistory: [] }
  ]
})
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
 //   NewdrugPage,
  //  LoginPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    FirebaseProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts